var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpertWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 441,
    height: 521,
    viewBox: "0 0 441 521",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_63_1181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.066 520.376V414.924H84.6783C70.6781 414.924 59.2748 403.52 59.2748 389.52V287.906H0L59.2748 186.292C61.6458 78.6945 153.098 -6.99992 262.954 0.451769C357.229 6.77441 433.666 83.5494 439.875 177.712C442.811 222.422 430.278 264.083 407.133 297.842C387.826 325.955 368.294 355.536 362.536 389.182C349.891 463.811 349.891 520.263 349.891 520.263H130.066V520.376Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.5 392.633H153.791V415.214H114.5V392.633Z",
    fill: "#CCCCCC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_63_1181"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 441,
    height: 521,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertWhite);
export default __webpack_public_path__ + "static/media/expert-white.23b03c896f53c7211669e066197bb59d.svg";
export { ForwardRef as ReactComponent };